import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.932 5.546a1 1 0 0 1-1-1V1.28a1 1 0 0 1 1-1h9.925a1 1 0 0 1 0 2h-8.925v2.266a1 1 0 0 1-1 1m-3.895 10.75a1 1 0 0 0 1 1h12.82a1 1 0 1 0 0-2h-11.82v-6.5h11.82a1 1 0 1 0 0-2h-12.82a1 1 0 0 0-1 1zM.436 8.976a1 1 0 0 1 1.414 0l1.655 1.656 1.656-1.656a1 1 0 1 1 1.414 1.414l-1.656 1.656L6.575 13.7a1 1 0 1 1-1.414 1.414L3.505 13.46 1.85 15.115a1 1 0 0 1-1.414-1.414l1.655-1.655L.436 10.39a1 1 0 0 1 0-1.414m11.496 10.57a1 1 0 0 1 2 0v2.266h8.925a1 1 0 0 1 0 2h-9.925a1 1 0 0 1-1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const TableRowRemove = { render };
export {
  TableRowRemove as default,
  render
};
//# sourceMappingURL=TableRowRemove.svg.js.map
